"use client";
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    DiagramSankey: function() {
        return DiagramSankey;
    },
    default: function() {
        return _default;
    }
});
const _jsxruntime = require("react/jsx-runtime");
const _utils = require("@mui/material/utils");
const DiagramSankey = (0, _utils.createSvgIcon)(/*#__PURE__*/ (0, _jsxruntime.jsx)("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/ (0, _jsxruntime.jsx)("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M11.1679 20.5547C11.3534 20.8329 11.6656 21 12 21H22C22.5523 21 23 20.5523 23 20C23 19.4477 22.5523 19 22 19H12.5352L9.86852 15H22C22.5523 15 23 14.5523 23 14C23 13.4477 22.5523 13 22 13H8.01368C8.00395 12.9999 7.99422 12.9999 7.98448 13H2C1.44772 13 1 13.4477 1 14C1 14.5523 1.44772 15 2 15H7.46482L11.1679 20.5547ZM1 10C1 10.5523 1.44772 11 2 11H8C8.33435 11 8.64658 10.8329 8.83205 10.5547L12.5352 5H22C22.5523 5 23 4.55229 23 4C23 3.44772 22.5523 3 22 3H12C11.6656 3 11.3534 3.1671 11.1679 3.4453L7.46482 9H2C1.44772 9 1 9.44771 1 10Z",
        fill: "currentColor"
    })
}), "DiagramSankey");
const _default = DiagramSankey;
